import { Box, IconProps, Tab, Typography } from "@mui/material"
import ActionCard from "../../../../../actionPlans/pages/form/components/actionCard"
import { ReportCard } from "../report"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { BodySection } from "./types"
import { useTranslation } from "react-i18next"
import { resendReportTypes } from "../../../main/constants/typeResendReport"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { useState } from "react"
import { BodySectionActionIcons } from "../bodySectionActionIcons"
import { BodySectionActionBody } from "../bodySectionActionBody"
import { scheduleServiceFetch, userScheduleServiceFetch } from "../../../../../../utils/constants/callService"
import { formatGenerateReportResponse } from "../../methods/formatResponse"
import { NoResponse } from "../../../../../../components/errors/noResponse"
import { Status } from "../../../../../../utils/enums"
import dayjs from "dayjs"
import { Constants } from "@/utils/constants"

const BosySecton = ({ originStore, store, management, supervisor, reportData, questionId, createrUser, directManager, saveReportUrl, sendReport, status, typeOfQuestionnaire }: BodySection) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const areThereSupervisor = supervisor?.length > 1
    const [disable, setDisable] = useState<boolean>()
    const seeReport = ({ url }: { url?: string | null }) => {
        if (url) {
            window.open(url)
        }
    }
    const normalizeHex = (hex?: string | null) =>
        hex ? `#${String(hex).replace('#', '')}` : undefined

    const generateReport = async ({ id }: { id: string | number }) => {
        setDisable(true)
        if (typeOfQuestionnaire === 1) {
            const response = await scheduleServiceFetch.getGenerateReport({ id })
            if (!response?.errors) {
                const reportUrl = formatGenerateReportResponse({ response })
                if (reportUrl) {
                    saveReportUrl({ url: reportUrl })
                    window.open(reportUrl)
                }
            }
        } else {
            const response = await userScheduleServiceFetch.getGenerateReport({ id })
            if (!response?.errors) {
                const reportUrl = formatGenerateReportResponse({ response })
                if (reportUrl) {
                    saveReportUrl({ url: reportUrl })
                    window.open(reportUrl)
                }
            }
        }
        setDisable(false)
    }
    const [value, setValue] = useState('1');

    const handleChange = (_: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box>
            <TabContext value={value} >
                <Box>
                    <TabList onChange={handleChange} sx={styles.tabs}>
                        <Tab label={t('schedule.bodySection.planningInformation')} value="1" />
                        <Tab label={t('schedule.bodySection.reporting')} value="2" />
                    </TabList>
                </Box>
                <TabPanel value="1" sx={styles.tabsPanel}>
                    <Box sx={styles.container}>
                        {!!store?.title && (<>
                            <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('useScheduled.referenceStore')}</Typography>
                            <ActionCard>
                                <Box sx={styles.iconTitle}>
                                    <ActionCard.Icon<IconProps> sx={styles.icon} color="primary_company" icon={icons('store')} />

                                    <Box sx={styles.titleRow}>
                                        {/* Título */}
                                        <ActionCard.Title variant="subtitle" fontWeight="bold" label={store?.title} />

                                        {/* Estado inline */}
                                        {!!store?.statusInline?.text && !!store?.statusInline?.color && (
                                            <Typography component="span" sx={styles.inlineStatusWrap}>
                                                {' - '}
                                                <Typography component="span" sx={{ ...styles.inlineStatusText, color: store.statusInline.color }}>
                                                    {store.statusInline.text}
                                                </Typography>
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>


                                <ActionCard.Description variant="subtitle" label={store?.description} />
                                <ActionCard.Description variant="subtitle" label={t('general.timeZoneDetail', { timeZone: store?.timeZone })} />
                            </ActionCard>
                        </>)}

                        {!!originStore && (<>
                            <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('useScheduled.referenceOrigynStore')}</Typography>
                            <ActionCard>
                                <Box sx={styles.iconTitle}>
                                    <ActionCard.Icon<IconProps> sx={styles.icon} color="primary_company" icon={icons('store')} />

                                    <Box sx={styles.titleRow}>
                                        {/* Título */}
                                        <ActionCard.Title variant="subtitle" fontWeight="bold" label={`${originStore?.name} - ${originStore?.keyCode}`} />

                                        {/* Estado inline */}
                                        {!!originStore?.storeStatus && (
                                            <Typography component="span" sx={styles.inlineStatusWrap}>
                                                {' - '}
                                                <Typography component="span" sx={{ ...styles.inlineStatusText, color: normalizeHex(originStore.storeStatus.color) }}>
                                                    {originStore.storeStatus.name}
                                                </Typography>
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>


                                <ActionCard.Description variant="subtitle" label={`${dayjs(originStore?.updateTime).locale('es').format(Constants.dayjsFormat4)}, ${originStore?.address} ${originStore?.email ?? ''} ${originStore?.phone && originStore?.phone.length > 1 ? `/ ${originStore?.phone}` : ''}`} />
                                <ActionCard.Description variant="subtitle" label={t('general.latitude', { latitude: originStore?.latitude })} />
                                <ActionCard.Description variant="subtitle" label={t('general.longitude', { longitude: originStore?.longitude })} />
                            </ActionCard>
                        </>)}

                        {
                            directManager?.length && (
                                <Box sx={styles.users}>
                                    <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('general.directSuperiors')}</Typography>

                                    <Box sx={directManager?.length > 1 ? styles.scroll : {}}>
                                        {
                                            !!directManager?.length && directManager?.map((parent) => (
                                                <ActionCard>
                                                    <Box sx={styles.flex}>
                                                        <BodySectionActionBody title={parent.title} userType={parent.userType} curp={parent.curp} role={parent.role} />

                                                        <BodySectionActionIcons email={parent.email} phone={parent.phone} />
                                                    </Box>
                                                </ActionCard>
                                            ))
                                        }
                                    </Box>
                                </Box>
                            )
                        }

                        {
                            !!createrUser && (
                                <Box sx={styles.users}>
                                    <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('general.createdByUser')}</Typography>

                                    <ActionCard>
                                        <Box sx={styles.flex}>
                                            <BodySectionActionBody title={createrUser.title} userType={createrUser.userType} curp={createrUser.curp} role={createrUser.role} />

                                            <BodySectionActionIcons email={createrUser.email} phone={createrUser.phone} />
                                        </Box>
                                    </ActionCard>
                                </Box>
                            )
                        }

                        {
                            !!management && (
                                <Box sx={styles.users}>
                                    <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('general.usersAssigned')}</Typography>

                                    <ActionCard>
                                        <Box sx={styles.flex}>
                                            <BodySectionActionBody title={management.title} userType={management.userType} curp={management.curp} role={management.role} />

                                            <BodySectionActionIcons email={management.email} phone={management.phone} />
                                        </Box>
                                    </ActionCard>
                                </Box>
                            )
                        }

                        {
                            !!supervisor?.length && (
                                <Box sx={styles.users}>
                                    <Typography sx={styles.title} fontWeight='bold' variant="title_main">{t('general.supervisor')}</Typography>

                                    <Box sx={areThereSupervisor ? styles.scroll : {}}>
                                        {
                                            !!supervisor?.length && supervisor?.map((supervisor) => (
                                                <ActionCard>
                                                    <Box sx={styles.flex}>
                                                        <BodySectionActionBody title={supervisor.title} userType={supervisor.userType} curp={supervisor.curp} role={!areThereSupervisor ? supervisor.role : undefined} />

                                                        <BodySectionActionIcons email={supervisor.email} phone={supervisor.phone} />
                                                    </Box>
                                                </ActionCard>
                                            ))
                                        }
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>
                </TabPanel>
                <TabPanel value="2" sx={styles.tabsPanel}>
                    <Box sx={styles.container}>
                        {
                            (!reportData?.report?.url) && (!reportData?.lastReport?.url) && (!reportData?.infoReport?.url) && (status !== Status.FINISHED) && (
                                <NoResponse label={t('Questionarie.NoReportsAvailable')} />
                            )
                        }
                        {
                            ((!!reportData?.report?.date && !!reportData?.report?.url) || status === Status.FINISHED) && (
                                <ReportCard
                                    title={reportData?.report?.type == 1 ? t('schedule.reportbyList') : t('schedule.reportByDetail')}
                                    date={reportData?.report?.date ?? ''}
                                    seeReport={() => { reportData?.report?.url ? seeReport({ url: reportData?.report?.url }) : generateReport({ id: questionId }) }}
                                    sendReport={() => { sendReport(reportData?.report?.type == 1 ? undefined : { queston: { id: questionId } }) }}
                                    disable={disable}
                                />
                            )
                        }

                        {
                            (!!reportData?.lastReport?.date && !!reportData?.lastReport?.url) && (
                                <ReportCard
                                    title={t('schedule.lastReport')}
                                    date={reportData?.lastReport?.date ?? ''}
                                    seeReport={() => { seeReport({ url: reportData?.lastReport?.url }) }}
                                />
                            )
                        }

                        {
                            (!!reportData?.infoReport?.date && !!reportData?.infoReport?.url) && (
                                <ReportCard
                                    title={t('schedule.reportInform')}
                                    date={reportData?.infoReport?.date ?? ''}
                                    seeReport={() => { seeReport({ url: reportData?.infoReport?.url }) }}
                                    sendReport={() => { sendReport({ queston: { id: questionId, }, type: resendReportTypes.results_report }) }}
                                />
                            )
                        }
                    </Box>
                </TabPanel>
            </TabContext>
        </Box>
    )
}

export { BosySecton }